import * as React from "react";
import { formatCurrency, formatDate } from "app/utils/filters";
import { Link } from "react-router-dom";
import { ColumnConfig } from "../ConfigurableTable";
import BackOfficeAndSnapminLink from "../../BOComponents/BackOfficeAndSnapminLink";
import WithholdWithdrawalButton from "./WithholdWithdrawalButton";
import PauseWithdrawalButton from "./PauseWithdrawalButton";
import ResumeWithdrawalButton from "./ResumeWithdrawalButton";
import { DeviceFraudStatusIcon } from "app/components/AppComponents/Fraud";

type GqlComment = {
  comment: string;
  status: string;
  updated_at: string;
  user: string;
};

type GqlDeviceFraudRequest = {
  device_only_fraud_status: string;
  external_reference: string;
  updated_at: string;
  token: string;
  suspicious_token_status: string;
  suspicious_token_comments: Array<GqlComment>;
  phone_number: string;
  suspicious_phone_number_status: string;
  suspicious_phone_number_comments: Array<GqlComment>;
};

export type GqlWithdrawalRequest = {
  created_at: string;
  reference: string;
  user: {
    external_reference: string;
    email: string;
    snapmin_url: string;
    devices: Array<GqlDeviceFraudRequest>;
  };
  payable_amount: number;
  status: string;
  withdrawal_batch: {
    id: string;
    status: string;
  };
};

export const columnConfigFactory = (
  onAction: () => void
): Array<ColumnConfig> => [
  {
    name: "Created At",
    render: (withdrawal: GqlWithdrawalRequest) =>
      formatDate(withdrawal.created_at),
  },
  {
    name: "User",
    render: (withdrawal: GqlWithdrawalRequest) => (
      <BackOfficeAndSnapminLink
        backofficeUrl={`/snapscan/ops/users/${withdrawal.user.external_reference}/withdrawals`}
        snapminUrl={withdrawal.user.snapmin_url}
      >
        {withdrawal.user.email}
      </BackOfficeAndSnapminLink>
    ),
  },
  {
    name: "Payable Amount",
    render: (withdrawal: GqlWithdrawalRequest) =>
      `R${formatCurrency(withdrawal.payable_amount)}`,
  },
  {
    name: "Status",
    render: (withdrawal: GqlWithdrawalRequest) => withdrawal.status,
  },
  {
    name: "Fraud Status",
    render: (withdrawal: GqlWithdrawalRequest) => (
      <DeviceFraudStatusIcon
        device={
          withdrawal.user.devices.sort((a, b) =>
            b.updated_at >= a.updated_at ? 1 : -1
          )[0]
        }
      />
    ),
  },
  {
    name: "Batch",
    render: (withdrawal: GqlWithdrawalRequest) =>
      withdrawal.withdrawal_batch?.id ? (
        <Link
          className="blueLink"
          to={`/snapscan/settlements/withdrawals/batches/${withdrawal.withdrawal_batch.id}/summary`}
        >
          {withdrawal.withdrawal_batch.id}
        </Link>
      ) : null,
  },
  {
    name: "Actions",
    render: (withdrawal: GqlWithdrawalRequest) => {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {withdrawal.status === "reserved" ||
          withdrawal.withdrawal_batch?.status === "pending" ? (
            <WithholdWithdrawalButton
              withdrawalReference={withdrawal.reference}
              onAction={onAction}
            />
          ) : null}
          {(withdrawal.status === "reserved" ||
            withdrawal.status === "released") &&
          withdrawal.withdrawal_batch?.status !== "submitted" ? (
            <PauseWithdrawalButton
              withdrawalReference={withdrawal.reference}
              onAction={onAction}
            />
          ) : null}
          {withdrawal.status === "paused" ? (
            <ResumeWithdrawalButton
              withdrawalReference={withdrawal.reference}
              onAction={onAction}
            />
          ) : null}
        </div>
      );
    },
  },
];

export default columnConfigFactory;
